import { useMemo, useState } from 'react';
import { useIntl } from 'react-intl';
import { MiniappSdkDemoInput } from 'app/pages/miniapp-sdk-demo/miniapp-sdk-demo-input';
import { MiniappSdkMethodDemo } from 'app/pages/miniapp-sdk-demo/miniapp-sdk-method-demo';

export const MiniappSdkStorageSetDemo = (): JSX.Element => {
  const intl = useIntl();
  const [storageKey, setStorageKey] = useState('');
  const [storageValue, setStorageValue] = useState('');
  const args = useMemo(() => [storageKey, storageValue], [storageKey, storageValue]);

  return (
    <MiniappSdkMethodDemo actionGroup="storage" action="set" eventName="setStorageResponse" args={args}>
      <MiniappSdkDemoInput
        value={storageKey}
        onChange={setStorageKey}
        placeholder={intl.formatMessage({ id: 'sdkDemo.placeholders.storageKey' })}
        dataTestId="storageSetKey"
      />
      <MiniappSdkDemoInput
        value={storageValue}
        onChange={setStorageValue}
        placeholder={intl.formatMessage({ id: 'sdkDemo.placeholders.storageValue' })}
        dataTestId="storageSetValue"
      />
    </MiniappSdkMethodDemo>
  );
};
